import { domain, tempDomain, azureClientId, azureTenantId, apiKey, stage } from './config-current'

export const Stage = stage

export const ApiGateway =  {
  apiKey,
  domain,
  tempDomain,
  employee: `${domain}/employees`,
  profile: `${domain}/profile`,
  user: `${domain}/users`,
  manufacturerProfile: `${tempDomain}/manufacturer-profiles`,
  assessments: `${tempDomain}/assessments`,
  fileUpload: `${domain}/mfi-file-upload`,
  fileDownload: `${domain}/mfi-file-upload/getFile`,
  auth: 'non-expiring-55B7ACB7F40F4A32B74065FC5FF770F3'
}

export const AzureAdClient = {
  info: {
    clientId: `${azureClientId}`,
    tenantId: `${azureTenantId}`
  },
  auth: {
    clientId: `${azureClientId}`,
    authority: `https://login.microsoftonline.com/${azureTenantId}`
  }
}
